import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import LinkPartnerPopup from "../../../common/components/LinkPartner/LinkPartnerPopup";

type LinkedAccount = {
  crmTenantName?: string;
  crmTenantId?: string;
};

type ProviderProfileDetails = {
 linked_accounts?: LinkedAccount;
  businessName?: string;
  businessEmail?: string;
  phoneNumber?: string;
};

type Props = {
  providerProfileDetails?: ProviderProfileDetails;
  onSuccess?: () => void;
  onError?: (msg: string) => void;
};

const LinkPartnerSection: React.FC<Props> = ({
  providerProfileDetails,
  onSuccess,
  onError,
}) => {
  const [openLinkPopup, setOpenLinkPopup] = useState(false);

  const linkedAccount = providerProfileDetails?.linked_accounts || null;
  const formatPhoneNumber = (fullNumber: string) => {
  if (!fullNumber) return { countryCode: "+1", number: "" };

  const match = fullNumber.match(/^(\+\d{1,3})\s*(\d{10})$/);
  if (match) {
    return { countryCode: match[1], number: match[2] };
  }
  return { countryCode: "+1", number: fullNumber.slice(-10) };
};
const { countryCode, number } = formatPhoneNumber(providerProfileDetails?.phoneNumber || "");
  return (
    <Box className="provider-profile-form__security" sx={{ mb: "4rem" }}>
      <Typography className="provider-profile-form__securityTitle">
        Linked Accounts
      </Typography>

      {linkedAccount?.crmTenantName ? (
        <Typography>
          CRM Partner Name : {linkedAccount.crmTenantName}
        </Typography>
      ) : (
        <Typography>
          -{" "}
          <span
            onClick={() => setOpenLinkPopup(true)}
            style={{
              color: "#009689",
              cursor: "pointer",
              marginLeft: 6,
              textDecoration: "underline",
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Link Partner
          </span>
        </Typography>
      )}

      <LinkPartnerPopup
        open={openLinkPopup}
        onClose={() => setOpenLinkPopup(false)}
        onSuccess={onSuccess}
        onError={onError}
        partnerDetails={{
        type:"provider",
        companyName: providerProfileDetails?.businessName || "",
        email: providerProfileDetails?.businessEmail || "",
        phoneNumber:number || "",
        countryCode: countryCode,
        id:providerProfileDetails?.id || null
    }}
      />
    </Box>
  );
};

export default LinkPartnerSection;
